/**
 * List of all the events that are tracked in the app.
 *
 * All new events should be named in snake_case like so: `verb_noun`
 */

export enum AnalyticsTrackingEvent {
  OPEN_APP = 'app open',
  FINGERPRINTJS_ERROR = 'fingerprintjs_error',
  GRAPHQL_ERROR = 'graphql_error',
  BRANDCLUB_LANDING_PAGE_LOADED = 'brandclub_landing_page_loaded',
  BRANDCLUB_LANDING_PAGE_TEXT_APP_LINK = 'brandclub_landing_page_text_app_link',
  BRANDCLUB_LANDING_PAGE_QRCODE_SCANNED = 'brandclub_landing_page_qrcode_scanned',
  JOINED_BRANDCLUB = 'joined brandclub',
  OPENED_SHARE_AFFILIATE_LINK = 'Opened share affiliate link',
  OPENED_SHARE_REFERRAL_CODE = 'Opened share referral code',
  OPENED_SHARE_PAGE_CARD_LINK = 'Opened share page card link',
  CLOSED_SHARE_AFFILIATE_LINK = 'Closed share affiliate link',
  CLOSED_SHARE_REFERRAL_CODE = 'Closed share referral code',
  CLOSED_SHARE_PAGE_CARD_LINK = 'Closed share page card link',
  SHARED_AFFILIATE_LINK = 'Shared affiliate link',
  SHARED_REFERRAL_CODE = 'Shared referral code',
  SHARED_PAGE_CARD_LINK = 'Shared page card link',
  TEST_EVENT = 'test event',
  MESSAGE_DETAIL_PAGE_OPENED = 'messageDetailPage opened',
  MESSAGE_DETAIL_PAGE_LINK_CLICKED = 'messageDetailPage link clicked',
  SELECTED_SEARCH_TERM_FROM_DROPDOWN = 'selected search term from dropdown',
  SERVER_SIDE_SYNC_MFA_CHOOSE_OPEN = 'server_side_sync_mfa_choose_open',
  SERVER_SIDE_SYNC_MFA_CHOOSE_SUCCESS = 'server_side_sync_mfa_choose_success',
  SERVER_SIDE_SYNC_MFA_CHOOSE_ERROR = 'server_side_sync_mfa_choose_error',
  SERVER_SIDE_SYNC_MFA_ENTER_OPEN = 'server_side_sync_mfa_enter_open',
  SERVER_SIDE_SYNC_MFA_ENTER_SUCCESS = 'server_side_sync_mfa_enter_success',
  SERVER_SIDE_SYNC_MFA_ENTER_ERROR = 'server_side_sync_mfa_enter_error',
  SERVER_SIDE_SYNC_MFA_TEXT_MESSAGE_ENTER_SUCCESS = 'server_side_sync_mfa_text_message_enter_success',
  SERVER_SIDE_SYNC_MFA_TEXT_MESSAGE_CHOOSE_SUCCESS = 'server_side_sync_mfa_text_message_choose_success',
  SAVE_REVIEW = 'save review',
  INVALID_REVIEW = 'invalid review',
  SAVE_REVIEW_SUCCESS = 'save review success',
  ERROR_WHILE_SAVING_REVIEW = 'error while saving review',
  BACK_REVIEW = 'back_review',
  STARTED_SUBMIT_REVIEW = 'started submit review',
  SENDING_NON_ELIGIBLE_REVIEW_TO_BRAND = 'Sending non-eligible review to brand',
  SELECTED_APP_REVIEW_OPTION = 'selected app review option',
  SKIPPED_LEAVE_APP_REVIEW = 'skipped leave app review',
  CONTINUE_REVIEW = 'continue_review',
  STARTED_SCANNING = 'Started scanning',
  ERROR_WHILE_SCANNING = 'Error while scanning',
  COMPLETED_SCANNING = 'Completed scanning',
  RETAILER_SYNC_STARTED = 'retailer_sync_started',
  RETAILER_SYNC_COMPLETED = 'retailer_sync_completed',
  DISCONNECT_RETAILER = 'disconnect_retailer',
  MOBILE_APP_SOCIAL_LINK_OPEN_PRODUCT_PAGE = 'mobileApp:socialLink:openProductPage',
  MOBILE_APP_SOCIAL_LINK_PRODUCT_NOT_FOUND = 'mobileApp:socialLink:productNotFound',
  MOBILE_APP_SOCIAL_LINK_CLOSE_RETAILER_PRODUCT_PAGE = 'mobileApp:socialLink:closeRetailerProductPage',
  MOBILE_APP_ORGANIC_OPEN_PRODUCT_PAGE = 'mobileApp:organic:openProductPage',
  MOBILE_APP_ORGANIC_PRODUCT_NOT_FOUND = 'mobileApp:organic:productNotFound',
  MOBILE_APP_ORGANIC_CLOSE_RETAILER_PRODUCT_PAGE = 'mobileApp:organic:closeRetailerProductPage',
  MOBILE_APP_PRODUCT_PAGE_SCROLL = 'mobileApp:productPage:scroll',
  WEB_APP_SOCIAL_LINK_TEXT_APP_DOWNLOAD_LINK = 'webApp:socialLink:textAppDownloadLink',
  WEB_APP_ORGANIC_ADD_TO_CART = 'webApp:organic:addToCart',
  OPEN_RETAILER_PRODUCT_PAGE = 'openRetailerProductPage',
  WEB_APP_ORGANIC_OPEN_VIEW_OFFERS = 'webApp:organic:openViewOffers',
  WEB_APP_ORGANIC_OPEN_RETAILER_PRODUCT_PAGE = 'webApp:organic:openRetailerProductPage',
  WEB_APP_PRODUCT_PAGE_SCROLL = 'webApp:productPage:scroll',
  ACCOUNTS_HOME_RETAILERS = 'accounts_home_retailers',
  AUTO_SIGN_IN = 'auto sign in',
  ERROR_ON_NEXT_IN_SIGN_UP = 'error on next in sign up',
  OPENED_TERMS_OF_SERVICE = 'opened terms of service',
  OPENED_PRIVACY_POLICY = 'opened privacy policy',
  SIGN_UP = 'sign up',
  SIGN_IN = 'sign in',
  SIGN_OUT = 'sign out',
  SIGN_IN_FAILURE = 'sign in failure',
  COMPLETED_ONBOARDING = 'completed_onboarding',
  VERIFIED_PHONE_NUMBER = 'verified phone number',
  RESEND_PHONE_VERIFICATION = 'resend phone verification',
  ERROR_VERIFYING_PHONE_VERIFICATION_CODE = 'error verifying phone verification code',
  PASSWORD_RESET_ATTEMPTS = 'password reset attempts',
  PASSWORD_RESET_SUCCESSFUL = 'password reset successful',
  SELECTED_SIGN_UP_WITH_EMAIL = 'selected sign up with email',
  SELECTED_FEDERATED_SIGN_IN = 'selected federated sign in',
  LOGIN_SCREEN_VISITS = 'login screen visits',
  BC_CHECKOUT_OPEN_BAG_PAGE = 'bc_checkout_open_bag_page',
  WEBVIEW_WHITE_SCREEN = 'webview white screen',
  BRANDCLUB_SEARCH_TERM = 'brandclubSearchTerm',
  STARTED_TUTORIAL = 'started tutorial',
  COMPLETED_TUTORIAL = 'completed tutorial',
  DAILY_DEALS_PRODUCT_CARD_CLICK = 'Daily deals product card click',
  START_SURVEY = 'start_survey',
  SURVEY_FAILED = 'survey failed',
  SURVEY_RESTART = 'survey restart',
  SURVEY_CANCEL = 'survey cancel',
  COMPLETED_SURVEY = 'completed survey',
  BACK_SURVEY = 'back_survey',
  SELECTED_SURVEY_OPTION = 'selected_survey_option',
  START_CONTENT = 'start_content',
  RESTART_CONTENT = 'restart_content',
  CANCEL_CONTENT = 'cancel_content',
  BACK_CONTENT = 'back_content',
  CONTINUE_CONTENT = 'continue_content',
  FAILED_CONTENT = 'failed_content',
  COMPLETED_CONTENT = 'completed_content',
  CASH_OUT_REQUESTED = 'cash out requested',
  CASH_OUT_SUCCESS = 'cash out success',
  CASH_OUT_FAILED = 'cash out failed',
  EMPTY_CASH_OUT = 'empty_cash_out',
  SYNC_SUMMARY_NOTIFICATION = 'Sync Summary Notification',
  SEARCH = 'search',
  NO_SEARCH_RESULTS = 'no search results',
  SEARCH_ERROR = 'Search error',
  DEEPLINK_OPEN_SUCCESS = 'deeplink open success',
  DEEPLINK_OPEN_ERROR = 'deeplink open error',
  NOTIFICATION_OPEN_SUCCESS = 'notification open success',
  NOTIFICATION_OPEN_ERROR = 'notification open error',
  NOTIFICATION_USER_RESPONDED = 'notification user responded',
  OPENED_APP_LINK = 'opened app link',
  ERROR_OPENING_APP_LINK = 'error opening app link',
  ERROR_OPENING_BRANCH_APP_LINK = 'error opening branch app link',
  ERROR_PAGE = 'error page',
  WARNING = 'warning',
  ERROR = 'error',
  RETURN_PANIC = 'return panic',
  TOMBSTONE = 'tombstone: ',
  INITIATE_CHECKOUT = 'initiate_checkout',
  BAG_BUTTON_CLICKED = 'bag_button_clicked',
  VIEW_BAG = 'view_bag',
  EMPTY_BAG = 'empty_bag',
  BAG_FULL = 'bag_full',
  UPDATE_BAG_QUANTITY = 'update_bag_quantity',
  CLOSE_CHECKOUT_ERROR = 'close_checkout_error',
  CHECKOUT_ERROR = 'checkout_error',
  CHECKOUT_NEXT_RETAILER = 'checkout_next_retailer',
  SKIP_CHECKOUT = 'skip_checkout',
  VIEW_CHECKOUT_SUMMARY = 'view_checkout_summary',
  REMOVE_CHECKOUT_OUT_OF_STOCK = 'remove_checkout_out_of_stock',
  CONFIRM_CHECKOUT_PARTIAL_OUT_OF_STOCK = 'confirm_checkout_partial_out_of_stock',
  ALL_OUT_OF_STOCK = 'all_out_of_stock',
  ADD_PAYMENT_METHOD = 'add_payment_method',
  DELETE_PAYMENT_METHOD = 'delete_payment_method',
  UPDATE_PAYMENT_METHOD = 'update_payment_method',
  CANCEL_UPDATE_PAYMENT_METHOD = 'cancel_update_payment_method',
  SAVE_UPDATE_PAYMENT_METHOD = 'save_update_payment_method',
  ADD_ADDRESS = 'add_address',
  DELETE_ADDRESS = 'delete_address',
  UPDATE_ADDRESS = 'update_address',
  CANCEL_UPDATE_ADDRESS = 'cancel_update_address',
  SAVE_UPDATE_ADDRESS = 'save_update_address',
  UPDATE_SECURITY = 'update_security',
  CANCEL_UPDATE_SECURITY = 'cancel_update_security',
  SAVE_UPDATE_SECURITY = 'save_update_security',
  // CHECKOUT_SUCCESS = 'checkout_success',
  CANCEL_UPDATE_PROFILE = 'cancel_update_profile',
  SAVE_UPDATE_PROFILE = 'save_update_profile',
  BUY_AGAIN = 'buy_again',
  TRACK_PACKAGE = 'track_package',
  VIEW_PURCHASE = 'view_purchase',
  VIEW_PRODUCT = 'view_product',
  EMPTY_PURCHASES = 'empty_purchases',
  EMPTY_REWARDS = 'empty_rewards',
  GET_APP = 'get_app',
  REWARD_INFO = 'reward_info',
  CLOSE_HOME_MENU = 'close_home_menu',
  LANDING_PAGE_VIDEO_PLAY_STARTED = 'landingPage:videoPlayStarted',
  LANDING_PAGE_VIDEO_PLAY_PAUSED = 'landingPage:videoPlayPaused',
  LANDING_PAGE_VIDEO_PLAY_ENDED = 'landingPage:videoPlayEnded',
  PAGE_VIEW = 'page view',
  BC_USER_REQUESTED_CHECKOUT = 'bc_user_requested_checkout',
  BC_USER_ADDED_TO_BAG_FROM_URL = 'bc_user_added_to_bag_from_url',

  // Checkout V2 Events
  CHECKOUT_INTENT_CREATED = 'bc_checkout_intent_created',
  CHECKOUT_PAGE_VIEW = 'bc_checkout_page_view',
  CHECKOUT_STEP_VIEWED = 'bc_checkout_step_viewed',
  CHECKOUT_STEP_COMPLETED = 'bc_checkout_step_completed',
  CHECKOUT_STEP_ERROR = 'bc_checkout_step_error',

  CHECKOUT_RETAILER_FORGOT_PASSWORD_CLICK = 'bc_checkout_retailer_forgot_password_click',

  CHECKOUT_PAYMENT_ADD = 'bc_checkout_payment_add',
  CHECKOUT_PAYMENT_SELECT = 'bc_checkout_payment_select',

  CHECKOUT_ORDER_SUBMIT = 'bc_checkout_order_submit',
  CHECKOUT_ORDER_SUCCESS = 'bc_checkout_order_success',
  CHECKOUT_ORDER_FAILURE = 'bc_checkout_order_failure',
  CHECKOUT_GUEST_ORDER_SUBMIT = 'bc_checkout_guest_order_submit',

  CHECKOUT_SIGN_IN_PHONE_SUBMIT = 'bc_checkout_sign_in_phone_submit',
  CHECKOUT_SIGN_IN_OTP_POPUP_OPEN = 'bc_checkout_sign_in_otp_popup_open',
  CHECKOUT_SIGN_IN_OTP_SUBMIT = 'bc_checkout_sign_in_otp_submit',
  CHECKOUT_SIGN_IN_OTP_RESEND = 'bc_checkout_sign_in_otp_resend',
  CHECKOUT_SIGN_IN_SUCCESS = 'bc_checkout_sign_in_success',

  CHECKOUT_CONNECT_SCREEN_VISIT = 'bc_checkout_connect_screen_visit',
  CHECKOUT_CONNECT_OTP_POPUP_OPEN = 'bc_checkout_connect_otp_popup_open',
  CHECKOUT_CONNECT_OTP_SUBMIT = 'bc_checkout_connect_otp_submit',
  CHECKOUT_CONNECT_OTP_RESEND = 'bc_checkout_connect_otp_resend',
  CHECKOUT_CONNECT_OTP_TIMEOUT_RETRY = 'bc_checkout_connect_otp_timeout_retry',

  CHECKOUT_CONNECT_CREDENTIALS_POPUP_OPEN = 'bc_checkout_connect_credentials_popup_open',
  CHECKOUT_CONNECT_CREDENTIALS_SUBMIT = 'bc_checkout_connect_credentials_submit',
  CHECKOUT_CONNECT_CREDENTIALS_TIMEOUT_RETRY = 'bc_checkout_connect_credentials_timeout_retry',

  CHECKOUT_CONNECT_SUCCESS_SCREEN_VISIT = 'bc_checkout_connect_success',
  CHECKOUT_CONNECT_SUCCESS_TRACK_ORDER_CLICK = 'bc_checkout_connect_success_track_order_click',
  CHECKOUT_CONNECT_SUCCESS_CONTINUE_SHOPPING_CLICK = 'bc_checkout_connect_success_continue_shopping_click',

  CHECKOUT_SUMMARY_SCREEN_VISIT = 'bc_checkout_summary_visit',
  BUTTON_CLICK = 'button_click',

  DTC_ADD_ITEM_TO_BAG = 'dtc_add_item_to_bag',
  DTC_OPEN_BUYBOX = 'dtc_open_buybox',
  DTC_VIEW_PURCHASE_BENEFITS = 'dtc_view_purchase_benefits',
  DTC_UPDATE_ITEM_QUANTITY = 'dtc_update_cart_item_quantity',
  // for add to bag use AnalyticsTrackingEvent.WEB_APP_ORGANIC_ADD_TO_CART
  // for visit pdp use AnalyticsTrackingEvent.BC_CHECKOUT_OPEN_BAG_PAGE

  CHECKOUT_GUEST_CHECKOUT_REQUEST_RETURN = 'bc_checkout_guest_checkout_request_return',
  CHECKOUT_SWITCH_TO_GUEST_CHECKOUT = 'bc_checkout_switch_to_guest_checkout',

  // Concierge events
  CONCIERGE_SUGGESTED_PILL_CLICKED = 'concierge_suggested_pill_clicked',

  // ============================================================================
  // CONCIERGE ANALYTICS EVENTS
  // These events track user engagement with the concierge widget for analytics.
  // Event names match ConciergeAgentEvent enum in api-rewards for consistency.
  // ============================================================================

  /**
   * WIDGET_IMPRESSION - Fired when a concierge widget becomes visible to the user.
   * Used to calculate: pageviews where shoppers saw a concierge widget.
   *
   * Required Properties:
   * - pageUrl: string - Full URL of the page where widget is displayed
   * - pageName: string - Human-readable page name (e.g., "Product Detail Page", "Homepage")
   * - widgetType: 'floating_button' | 'embedded' | 'modal' - Type of widget displayed
   * - sessionId: string - Unique session identifier
   * - appName: string - Name of the brand app (e.g., "Bayer Aspirin Store")
   *
   * Optional Properties:
   * - stacklineSku: string - Product SKU if on a PDP
   * - brandId: number - Brand ID if applicable
   * - appConfigId: string - App configuration ID
   */
  CONCIERGE_WIDGET_IMPRESSION = 'concierge:widget_impression',

  /**
   * WIDGET_SESSION_START - Fired once per unique session when the widget is first viewed.
   * Used to calculate: unique session views of the concierge widget.
   * Should be deduplicated by sessionId (only fire once per session).
   *
   * Required Properties:
   * - sessionId: string - Unique session identifier
   * - appName: string - Name of the brand app
   * - referrer: string - Document referrer (how user arrived)
   * - deviceType: 'desktop' | 'mobile' | 'tablet' - User's device type
   *
   * Optional Properties:
   * - utmSource: string - UTM source parameter if present
   * - utmMedium: string - UTM medium parameter if present
   * - utmCampaign: string - UTM campaign parameter if present
   * - pageUrl: string - URL where session started
   */
  CONCIERGE_WIDGET_SESSION_START = 'concierge:widget_session_start',

  /**
   * CONVERSATION_ACCESS_POINT - Fired when a user initiates a conversation.
   * Used to track: where users start conversations from (entry points).
   *
   * Required Properties:
   * - accessPoint: Where the conversation was initiated. One of: 'search_bar',
   *   'feature_image', 'quick_prompts', 'floating_button', 'suggested_pill',
   *   'follow_up_question', 'conversation_starter', 'pdp_ask_question'
   * - conversationId: string - The conversation ID (may be new or existing)
   * - pageUrl: string - Full URL where conversation started
   *
   * Optional Properties:
   * - stacklineSku: string - Product SKU if initiated from a PDP
   * - query: string - The initial query/prompt text (truncated to 200 chars)
   * - isNewConversation: boolean - Whether this started a new conversation
   */
  CONCIERGE_CONVERSATION_ACCESS_POINT = 'concierge:conversation_access_point',

  /**
   * PAGE_CONTEXT - Fired to track the page context during a conversation.
   * Used to understand: what pages conversations happen on.
   *
   * Required Properties:
   * - conversationId: string - The active conversation ID
   * - pageUrl: string - Full URL of the current page
   * - pageName: string - Human-readable page name
   * - pageType: 'pdp' | 'brand' | 'brandclub' | 'search' | 'category' | 'homepage' | 'other'
   *
   * Optional Properties:
   * - stacklineSku: string - Product SKU if on a PDP
   * - brandId: number - Brand ID if on a brand page
   * - categoryId: number - Category ID if on a category page
   * - searchQuery: string - Search query if on a search results page
   */
  CONCIERGE_PAGE_CONTEXT = 'concierge:page_context',

  /**
   * PRODUCT_CLICK - Fired when a user clicks on a product in the concierge.
   * Used to calculate: clickthrough rates for product recommendations.
   *
   * Required Properties:
   * - conversationId: string - The active conversation ID
   * - stacklineSku: string - SKU of the clicked product
   * - productTitle: string - Title of the clicked product
   * - clickSource: 'carousel' | 'featured' | 'search_results' | 'comparison' | 'buy_box' -
   *                Where in the UI the product was clicked
   *
   * Optional Properties:
   * - productPosition: number - Position in the list (0-indexed)
   * - retailerId: number - Retailer ID of the product
   * - retailPrice: number - Price of the product
   * - hasReward: boolean - Whether the product has a reward
   * - rewardAmount: number - Reward amount if applicable
   * - messageIndex: number - Index of the message containing the product
   */
  CONCIERGE_PRODUCT_CLICK = 'concierge:product_click',

  /**
   * PRODUCT_SUGGESTED - Fired when a product recommendation is shown (impression).
   * Must align with server ConciergeAgentEvent.PRODUCT_SUGGESTED for Doris aggregates.
   *
   * Required Properties:
   * - conversationId: string
   * - stacklineSku: string
   */
  CONCIERGE_PRODUCT_SUGGESTED = 'concierge:product_suggested',

  /**
   * CONVERSATION_DELETE Event
   *
   * Track when a user deletes a conversation from the sidebar history.
   *
   * Required Properties:
   * - conversationId: string - The ID of the deleted conversation
   * - pageUrl: string - Current page URL
   */
  CONCIERGE_CONVERSATION_DELETE = 'concierge:conversation_delete',

  /**
   * AGREEMENT_SHOWN - Fired when the inline consent/agreement card is rendered
   * in response to the shopper submitting their first question while an
   * agreement is enabled and not yet accepted.
   */
  CONCIERGE_AGREEMENT_SHOWN = 'concierge:agreement_shown',

  /**
   * AGREEMENT_ACCEPTED - Fired when the shopper taps the agree button on the
   * consent/agreement card. Fired immediately before the pending prompt is
   * dispatched to the backend.
   */
  CONCIERGE_AGREEMENT_ACCEPTED = 'concierge:agreement_accepted',
}
